import Layout from '../shared/Layout';
import SessionsPanel from '../../components/settings/SessionsPanel';
import ThemeEditorPanel from '../../components/settings/ThemeEditorPanel';
import SettingsToolbar from '../../components/settings/SettingsToolbar';
import language from '../../variables/language';
import { useLocation } from 'react-router-dom';
import '../../css/settings.css';

const Settings = () => {
 const location = useLocation();
 const lang = language[language.lang];

  return (
    <Layout>
      <SettingsToolbar />
      <header  className='header-block'>
         <div className='header-txt txt-c' >{ lang[(location.pathname.replace("/",""))] }</div>
      </header>
      <main className='main-block' >
        <div className='main-content txt-c settings-body'>
          <div className='settings-body-left'>
            <ThemeEditorPanel />
          </div>
          <div className='settings-body-right'>
            <SessionsPanel />
          </div>
        </div>
      </main>

    </Layout>
  )
}

export default Settings
